import { render, staticRenderFns } from "./molecule.modal.confirmationShareYourDesign.vue?vue&type=template&id=771f4e0e"
import script from "./molecule.modal.confirmationShareYourDesign.vue?vue&type=script&lang=ts"
export * from "./molecule.modal.confirmationShareYourDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports